export const dispatchCreateClient = (dispatch, clientObjectToAdd, clients) => {
  dispatch({
    type: "UPDATE_CLIENTS",
    updateClients: [...clients.concat(clientObjectToAdd)],
  });
};

export const dispatchDeleteClient = (dispatch, clients, clientid) => {
  dispatch({
    type: "UPDATE_CLIENTS",
    updateClients: [...clients.filter((c) => c.id !== clientid)],
  });
};
